import React from 'react';
import { TextInput, Filter } from 'react-admin';

const LicensesFilter = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Filter {...props} data-testid="clients-filters">
    <TextInput key="filter01" label="ra.action.search" source="q" alwaysOn />
    <TextInput key="filter02" source="theme" />
    <TextInput key="filter03" source="status" />
  </Filter>
);

export default LicensesFilter;
